import React from 'react';
import Header from '../components/Header/Header';
import MarketsHero from '../components/MarketsHero/MarketsHero';
import FooterCTA from '../components/FooterCTA/FooterCTA';
import Footer from '../components/Footer/Footer';
import MarketsIntro from '../components/MarketsIntro/MarketsIntro';
import MarketDetail from '../components/MarketDetail/MarketDetail';


import grainsShowcaseImg from '../assets/images/grains-showcase.jpg';
import pulsesShowcaseImg from '../assets/images/pulses-showcase.jpg';
import oilseedsShowcaseImg from '../assets/images/oilseeds-showcase.jpg';
import spicesShowcaseImg from '../assets/images/spices-showcase.jpg';
import vegetablesShowcaseImg from '../assets/images/vegetables-showcase.jpg';
import sugarShowcaseImg from '../assets/images/sugar-showcase.jpg';

const MarketsPage = () => {
  return (
    <>
      <Header />
      <main>
        <MarketsHero />
        <MarketsIntro />
         <MarketDetail 
          title="Grains"
          subMarkets={['Wheat', 'Rice', 'Maize', 'Barley', 'Bajra']}
          description="Gain insights across upstream inputs and downstream products. CRISHI connects pricing data, trade flows, and supply-demand movements across the full grains value chain to support strategic and operational decisions."
          image={grainsShowcaseImg}
          imageAlt="A collection of various grains"
          buttonLink="/markets/grains"
          />
           <MarketDetail 
          title="Pulses"
          subMarkets={['Bengal Gram','Urad', 'Masoor', 'Moong','Tur','Pea']}
          description="Track non-ferrous markets with precision. From real-time pricing to macroeconomic drivers and regional dynamics, CRISHI supports procurement, analysis, and forecasting with credible, consistent intelligence."
          image={pulsesShowcaseImg}
          imageAlt="A collection of various pulses"
          reverse={true} // This prop reverses the layout
        />
         <MarketDetail 
          title="Oilseeds"
          subMarkets={['Soyabean', 'Rapeseed', 'Cotton', 'Groundnuts']}
          description="Track oilseed markets with precision. From real-time pricing to macroeconomic drivers and regional dynamics, CRISHI supports procurement, analysis, and forecasting with credible, consistent intelligence."
          image={oilseedsShowcaseImg}
          imageAlt="A collection of various oilseeds"
          // reverse prop is omitted, so it defaults to false (text-left, image-right)
        />
        <MarketDetail 
          title="Spices"
          subMarkets={['Chilli','Turmeric', 'Coriander', 'Cumin']}
          description="Access timely, verified insights into the core spice markets. Our coverage includes price benchmarks, logistics trends, and policy developments affecting spice-linked markets."
          image={spicesShowcaseImg}
          imageAlt="A collection of various spices"
          reverse={true} // This prop reverses the layout
        />
        <MarketDetail 
          title="Vegetables"
          subMarkets={['Tomato', 'Potato', 'Onion']}
          description="Track Vegetables markets with clarity. From real-time domestic and global prices to supply-demand shifts and export trends, CRISHI delivers intelligence that simplifies decisions across the Vege value chain."
          image={vegetablesShowcaseImg}
          imageAlt="A local Vegetable market"
          // reverse prop is omitted for the default layout
        />
        <MarketDetail 
          title="Sugar"
          subMarkets={['']}
          description="Understand how materials move across geographies with data on freight rates, port activity, shipment delays, and inland logistics. CRISHI's logistics layer helps you interpret price signals for operational efficiency."
          image={sugarShowcaseImg}
          imageAlt="Sugarcane ready for processing"
          reverse={true} // This prop reverses the layout
        />

        {/* You can add more market-specific sections here later */}
        <FooterCTA />
      </main>
      <Footer />
    </>
  );
};

export default MarketsPage;